import * as fflate from "fflate";

// // // //
// Utility functions for generating garbage

function removeFirst20Chars(str: string) {
    return str.substring(20);
}
function removeLast25Chars(str: string) {
    return str.slice(0, -25);
}

function generateRandomChars(length: number) {
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength),
        );
    }
    return result;
}

function addRandomChars(str: string) {
    const randomCharsStart = generateRandomChars(20);
    const randomCharsEnd = generateRandomChars(25);
    return randomCharsStart + str + randomCharsEnd;
}

function removeRandomChars(str: string) {
    const withoutLeading = removeFirst20Chars(str);
    const withoutEither = removeLast25Chars(withoutLeading);
    return withoutEither;
}

// // // //

/**
 * obfuscate
 * Accepts JSON data and returns an obfuscated string we can pass via tRPC
 * Designed to prevent unauthorized scraping of our APIs
 */
export function obfuscate(data: any) {
    // Stringify the JSON data
    const jsonString = JSON.stringify(data);

    // Encode the JSON string as a Uint8Array
    const d = new TextEncoder().encode(jsonString);

    // Reverse the array
    const reversedArr = d.reverse();

    // Compress the reversed array
    const compressed = fflate.compressSync(reversedArr);

    // Transform the array into a buffer (so tRPC can serialize it)
    const buf = Buffer.from(compressed.buffer);

    // Prepend + append leading/trailing junk to base64 encoded buffer
    return addRandomChars(buf.toString("base64"));
}

/**
 * deobfuscate
 * Accepts an obfuscated string passed via tRPC and returns parsed JSON data
 */
export function deobfuscate(data: string) {
    // Remove leading + trailing junk characters
    const comp = removeRandomChars(data);

    // Transform base64 -> Uint8Array
    const unit8Arr = Uint8Array.from(atob(comp), (c) => c.charCodeAt(0));

    // Decompress the data string
    const decompressed = fflate.decompressSync(unit8Arr);

    // Un-reverse the decompressed binary array
    const unreversed = decompressed.reverse();

    // Decode the binary array into a JSON string
    const jsonString = new TextDecoder().decode(unreversed);

    // Return the parsed JSON
    return JSON.parse(jsonString) as any;
}
